import SelectedSheet from 'components/hoc/SelectedSheet';
import SheetTile from 'components/SheetTile';
import {
  ManageDrawingsSupportContext,
  ManageDrawingsSupportValue,
} from 'providers/ManageDrawingsSupportProvider';
import React, { ReactElement } from 'react';
import { Sheet } from 'records/Sheet';

const PublishedDrawingRenderer = (
  style: React.CSSProperties,
  data: Sheet[][],
  columnIndex: number,
  rowIndex: number,
  handleSheetClick: (sheet: Sheet) => Promise<void>
): ReactElement => {
  const sheet = data[rowIndex][columnIndex] || new Sheet();
  const gridGutterSize = 16;
  const tileStyle = {
    ...style,
    left: style.left,
    top: style.top,
    width: style.width ? +style.width - gridGutterSize : 0,
    height: style.height ? +style.height - gridGutterSize : 0,
  };

  return sheet.sheetid !== '' ? (
    <ManageDrawingsSupportContext.Consumer key={sheet.sheetid}>
      {({ onSuccess }: ManageDrawingsSupportValue) => (
        <SelectedSheet key={sheet.sheetid} sheet={sheet}>
          {({ selected, handlePageSelectChange }): React.ReactNode => (
            <SheetTile
              style={tileStyle}
              key={sheet.sheetid}
              sheet={sheet}
              selected={selected}
              showCheckbox
              onSheetClick={(clickedSheet: Sheet) => {
                onSuccess(() => handleSheetClick(clickedSheet));
              }}
              onCheckboxChange={handlePageSelectChange}
            />
          )}
        </SelectedSheet>
      )}
    </ManageDrawingsSupportContext.Consumer>
  ) : (
    <div />
  );
};

export default PublishedDrawingRenderer;
